export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_DASHBOARD_BREAKOUT = 'SET_DASHBOARD_BREAKOUT'
export const SET_DASHBOARD_TOP3 = 'SET_DASHBOARD_TOP3'
export const SET_DASHBOARD_TOP = 'SET_DASHBOARD_TOP'
export const SET_DASHBOARD_PROFIT = 'SET_DASHBOARD_PROFIT'
export const SET_DASHBOARD_CYCLETIMES = 'SET_DASHBOARD_CYCLETIMES'
export const SET_DASHBOARD_TREND = 'SET_DASHBOARD_TREND'
export const SET_DATE = 'SET_DATE'
export const SET_VIEW = 'SET_VIEW'
export const SET_INVOICES = 'SET_INVOICES'
export const SET_PAYROLL = 'SET_PAYROLL'
export const SET_TECHDATA = 'SET_TECHDATA'
export const SET_DATA = 'SET_DATA'
export const SET_PAYMENTS = 'SET_PAYMENTS'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js